import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import UnderConstruction from "./pages/UnderConstruction";
import CorporateGovernance from "./pages/AboutUs/CorporateGovernance";
import PowerGeneration from "./pages/PowerGeneration/PowerGeneration";
import HydroPowerPage from "./pages/PowerGeneration/HydroPowerPage";
import AboutNeepcoPage from "./pages/AboutUs/AboutNeepcoPage";
import ScrollToTop from "./components/ScrollToTop";
import ThermalPowerPage from "./pages/PowerGeneration/ThermalPowerPage";
import SolarPowerPage from "./pages/PowerGeneration/SolarPowerPage";
import ChallengesDetailPage from "./pages/ChallengesDetailPage";
import PowerDetailPage from "./pages/PowerGeneration/PowerDetailPage/PowerDetailPage";
import ProjectsInPipelinePage from "./pages/PowerGeneration/ProjectsInPipelinePage";
import JointVenture from "./pages/PowerGeneration/JointVenture";
import PowerPotentialPage from "./pages/PowerGeneration/PowerPotentialPage";
import LatestNewsPage from "./pages/Home/LatestNews/LatestNewsPage";
import EventsDetailPage from "./pages/Home/Events/EventsDetailPage";
import VideoGalleryDetailPage from "./pages/VideoGalleryDetailPage";
import ContactUsPage from "./pages/ContactUsPage";
import ReservoirStatusPage from "./pages/Reservoirs/ReservoirStatusPage";
import ListOfTenders from "./pages/Tenders/ListOfTenders";
import EnvironmentPage from "./pages/SustainableDevelopment/Enviornment/EnvironmentPage";
import ListOfDebarredCompanies from "./pages/Tenders/ListOfDebarredCompanies";
import LatestNewsDetailPage from "./pages/Home/LatestNews/LatestNewsDetailPage";
import AwardedTenders from "./pages/Tenders/AwardedTenders";
import ArchivedTenders from "./pages/Tenders/ArchivedTenders";
import IntegrityPact from "./pages/Tenders/IntegrityPact";
import ProcurementPlanPage from "./pages/Tenders/ProcurementPlanPage";
import Covid19 from "./pages/FooterMenuPages/Covid19";
import SuccessfulBidders from "./pages/Tenders/SuccessfulBidders";
import SwachhBharatAbhiyan from "./pages/SustainableDevelopment/SwachhaBharat/SwachhBharatAbhiyan";
import PowerMapPage from "./pages/PowerGeneration/PowerDetailPage/PowerMapPage";
import EquityPage from "./pages/Investors/equity/EquityPage";
import BondsPage from "./pages/Investors/Bonds/BondsPage";
import RehabilitationPage from "./pages/SustainableDevelopment/Rehabilitation/RehabilitationPage";
import SwachBharatPhotos from "./pages/SustainableDevelopment/SwachhaBharat/SwachhBharatPhotos";
import CorporateGovernanceUpdate from "./pages/Investors/CorporateGovernanceUpdate";
import TariffPetition from "./pages/Commercial/TariffPetition";
import CommercialActivities from "./pages/Commercial/commercialAcitvities/CommercialActivities";
import ReportPage from "./pages/FooterTopMenuPages/Reports/ReportPage";
import Generation from "./pages/FooterMenuPages/Generation/Generation";
import EventsDetailById from "./pages/Home/Events/EventsDetailById";
import PhotoGalleryDetailPage from "./pages/Home/PhotoVideoPublication/Photos/PhotoGalleryDetailPage";
import PhotoDetailById from "./pages/Home/PhotoVideoPublication/Photos/PhotoDetailById";
import Feedback from "./pages/FooterTopMenuPages/Feedback";
import FooterBottomPage from "./pages/FooterBottomPage/FooterBottomPage";
import MissionVisionPage from "./pages/Home/MissionVisionPage";
import ExEmployeesPage from "./pages/FooterMiddlePages/ExEmployeesPage";
import MseStartups from "./pages/FooterMiddlePages/MseStartups";
import ContractualVendorsPage from "./pages/FooterMiddlePages/ContractualVendorsPage";
import OfferWorks from "./pages/FooterMiddlePages/OfferWorks";
import GuideLineForReleasePage from "./pages/FooterMiddlePages/GuideLineForReleasePage";
import ArchivedNews from "./pages/FooterMiddlePages/ArchivedNews";
import HelpPage from "./pages/FooterMiddlePages/HelpPage";
import Awards from "./pages/FooterMiddlePages/Awards/Awards";
import BeePaintingCompetition from "./pages/FooterMiddlePages/BeePaintingCompetition";
import CareerPage from "./pages/CareerPage";
import BoardOfDirectors from "./pages/AboutUs/BoardOfDirectors/BoardOfDirectors";
import HtmlPageById from "./pages/HtmlPageById";
import AnnouncementPage from "./pages/Home/Announcement/AnnouncementPage";
import ReportById from "./pages/FooterTopMenuPages/Reports/ReportById";
import OtherCelebrationsById from "./pages/FooterTopMenuPages/AzadiKaAmritMahotsav/OtherCelebrationsById";
import SwachhBharatTableById from "./pages/SustainableDevelopment/SwachhaBharat/SwachhBharatTableById";
import SwachhBharatGalleryById from "./pages/SustainableDevelopment/SwachhaBharat/SwachhBharatGalleryById";
import PerformanceHighlights from "./pages/PerformanceHighlights";
import HtmlPageByNode from "./pages/HtmlPageByNode";

import PublicationDetailById from "./pages/Home/PhotoVideoPublication/publications/PublicationDetailById";
import PublicationDetailPage from "./pages/Home/PhotoVideoPublication/publications/PublicationDetailPage";
import ScreenReaderAccess from "./pages/TopHeaderPages/ScreenReaderAccess";
import OthersPage from "./pages/Investors/OthersPage";
import Notices from "./pages/Commercial/notices/Notices";
import WaterLevelsDetailPage from "./pages/Reservoirs/WaterLevelsDetailPage";
import RainFallDetailPage from "./pages/Reservoirs/RainFallDetailPage";
import { useLanguageTranslation } from "./hooks/useLanguageTranslation";
import WaterTemp from "./pages/Reservoirs/WaterTemp";
import ImportantLinks from "./pages/TopHeaderPages/ImportantLinks";
import Sitemap from "./pages/TopHeaderPages/Sitemap";
import ResearchAndDevelopment from "./pages/FooterMiddlePages/ResearchAndDevelopment";
import CompetitionsAndCelebrations from "./pages/FooterTopMenuPages/AzadiKaAmritMahotsav/CompetitionsAndCelebrations";
import WebsitePolicies from "./pages/FooterBottomPage/WebsitePolicies";
import VideoGalleryById from "./pages/VideoGalleryById";
import SearchPage from "./pages/SearchPage";
import ArchivedNewsDetailPage from "./pages/FooterMiddlePages/ArchivedNewsDetailPage";
import EventArchivePage from "./pages/FooterMiddlePages/EventArchive/EventArchivePage";
import EventArchiveDetailPage from "./pages/FooterMiddlePages/EventArchive/EventArchiveDetailPage";
import ExternalPage from "./pages/Home/ExternalPage";
import SwachhVidyalayaAbhiyanPage from "./pages/SwachhVidyalayaAbhiyan/SwachhVidyalayaAbhiyanPage";
import ArchiveFooterPage from "./pages/FooterTopMenuPages/ArchiveFooterPage";
import CsrActivitiesPageNew from "./pages/CSR/CsrActivitiesPageNew";
import CitizenCharterPage from "./pages/AboutUs/CitizensCharter/CitizenCharterPage";
import PhotoGalleryAndEvents from "./pages/NewsRoom/PhotoGalleryAndEvents";
import UnderConstructionDams from "./pages/PowerGeneration/UnderConstructionDams";
import SustainabilityPolicyReport from "./pages/SustainableDevelopment/SustainabilityPolicyReport";
import RtiPage from "./pages/FooterTopMenuPages/RTI/RtiPage";
import ArchivedPublications from "./pages/FooterMiddlePages/ArchivedPublications";
import RtiHtmlPageByNode from "./pages/RtiHtmlPageByNode";
import PropertyReturn from "./pages/FooterMiddlePages/PropertyReturn";
import PhotoGalleryArchiveDetailPage from "./pages/FooterMiddlePages/PhotoGalleryArchiveDetailPage";
import PhotoDetailByIdArchive from "./pages/FooterMiddlePages/PhotoDetailByIdArchive";
import ComprehensiveGuidelinePage from "./pages/FooterMiddlePages/ComprehensiveGuidelinePage";
import PreBidClarifications from "./pages/Tenders/PreBidClarifications";
import ListOfTechnoCommerciallyQualifiedBidders from "./pages/Tenders/ListOfTechnoCommerciallyQualifiedBidders";
import PrivateRoute from "./routes/PrivateRoute";
function AppRouting() {
  const { getText } = useLanguageTranslation();

  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* top header menus */}
        <>
          <Route path="/screen-reader" element={<ScreenReaderAccess />} />
          <Route path="/important-links" element={<ImportantLinks />} />
          <Route path="/sitemap" element={<Sitemap />} />
        </>
        {/* about us */}
        <>
          <Route path="/about-us/about-neepco" element={<AboutNeepcoPage />} />
          <Route
            path="/about-us/board-of-directors"
            element={<BoardOfDirectors />}
          />
          <Route
            path="/about-us/citizen-charter"
            element={<CitizenCharterPage />}
          />
          <Route
            path="/about-us/corporate-governance"
            element={<CorporateGovernance />}
          />
        </>
        {/* power generation */}
        <>
          <Route path="/power-generation" element={<PowerGeneration />} />
          <Route
            path="/power-generation/hydro-power"
            element={<HydroPowerPage />}
          />
          <Route
            path="/power-generation/thermal-power"
            element={<ThermalPowerPage />}
          />
          <Route
            path="/power-generation/solar-power"
            element={<SolarPowerPage />}
          />
          <Route
            path="/power-generation/projects-in-pipeline"
            element={<ProjectsInPipelinePage />}
          />
          <Route
            path="/power-generation/joint-venture"
            element={<JointVenture />}
          />
          <Route path="/power-generation/map" element={<PowerMapPage />} />
          <Route
            path="/power-generation/power-potential"
            element={<PowerPotentialPage />}
          />
          <Route
            path="/power-generation/project-under-construction"
            element={<UnderConstructionDams />}
          />
        </>
        {/* sustainable development */}
        <>
          <Route
            path="/sustainable-development/environment"
            element={<EnvironmentPage />}
          />
          <Route
            path="/sustainable-development/rehabilitation-and-resettlement"
            element={<RehabilitationPage />}
          />
          <Route
            path="/sustainable-development/swachh-bharat-abhiyan"
            element={<SwachhBharatAbhiyan />}
          />{" "}
          <Route
            path="/sustainable-development/sustainability-policy-report"
            element={<SustainabilityPolicyReport />}
          />
          <Route
            path="/sustainable-development/swachh-vidyalaya-abhiyan"
            element={<SwachhVidyalayaAbhiyanPage />}
          />
          <Route
            path="/sustainable-development/swachh-bharat-abhiyan/:id"
            element={<SwachhBharatGalleryById />}
          />
          <Route
            path="/sustainable-development/swachh-bharat-abhiyan-table/:id"
            element={<SwachhBharatTableById />}
          />
          {/* <Route
            path="/sustainable-development/csr"
            element={<CsrActivitiesPage />}
          /> */}
          <Route
            path="/sustainable-development/csr"
            element={<CsrActivitiesPageNew />}
          />
        </>
        {/* tender menu routes */}
        <>
          <Route path="/tender/list-of-tenders" element={<ListOfTenders />} />
          <Route
            path="/tender/queries-posted-by-bidders"
            element={<PreBidClarifications />}
          />
          <Route path="/tender/tenders-awarded" element={<AwardedTenders />} />
          <Route
            path="/tender/qualified-bidders"
            element={<ListOfTechnoCommerciallyQualifiedBidders />}
          />
          <Route
            path="/tender/successful-bidders"
            element={<SuccessfulBidders />}
          />
          <Route
            path="/tender/procurement-plan"
            element={<ProcurementPlanPage />}
          />
          <Route path="/tender/integrity-pact" element={<IntegrityPact />} />
          {/* e-tender */}
          <Route path="/tender/archive-tender" element={<ArchivedTenders />} />

          <Route
            path="/tender/list-of-debarred-companies"
            element={<ListOfDebarredCompanies />}
          />
        </>
        {/* investor menus */}
        <>
          <Route path="/investors/equity" element={<EquityPage />} />
          <Route path="/investors/bonds" element={<BondsPage />} />
          <Route
            path="/investors/corporate-governance-updates"
            element={<CorporateGovernanceUpdate />}
          />
          <Route path="/investors/others" element={<OthersPage />} />
        </>
        {/* commercial menus */}
        <>
          <Route
            path="/commercial/tariff-petition"
            element={<TariffPetition />}
          />
          <Route path="/commercial/notices" element={<Notices />} />
          <Route
            path="/commercial/commercial-activities"
            element={<CommercialActivities />}
          />
        </>
        {/* career main menu */}
        <Route path="/career" element={<CareerPage />} />
        {/* footer menu pages */}
        <>
          <Route path="/covid-19" element={<Covid19 />} />
          <Route path="/contact-us" element={<ContactUsPage />} />
          <Route
            path="/reservoir-status"
            element={
              <PrivateRoute>
                <ReservoirStatusPage />
              </PrivateRoute>
            }
          />
          <Route path="/reports" element={<ReportPage />} />
          <Route
            path="/reports/:id"
            element={
              <ReportById
                apiPath={"reports"}
                title={"Annual Report"}
                titleLink={"/reports"}
              />
            }
          />
          <Route
            path="/competition-celebrations"
            element={<CompetitionsAndCelebrations />}
          />
          <Route
            path="/other-celebrations/:id"
            element={<OtherCelebrationsById />}
          />
          <Route path="/rti" element={<RtiPage />} />
          <Route path="/rti/:nid" element={<RtiHtmlPageByNode />} />
          <Route path="/feedback" element={<Feedback />} />
        </>
        {/* footer bottom menu pages */}
        <>
          <Route path="/generation" element={<Generation />} />
        </>
        {/* home detail pages */}
        <>
          <Route path="/" element={<Home />} />
          <Route path="/mission-vision/:id" element={<MissionVisionPage />} />

          <Route path="/challenges/:id" element={<ChallengesDetailPage />} />

          <Route
            path="/power-generation/:type/:id"
            element={<PowerDetailPage />}
          />

          <Route
            path="/video-gallery-detail"
            element={<VideoGalleryDetailPage />}
          />
          <Route
            path="/video-gallery-detail/:id"
            element={<VideoGalleryById />}
          />
          <Route
            path="/publication-detail"
            element={<PublicationDetailPage />}
          />
          <Route
            path="/news-room-media/publications"
            element={<PublicationDetailPage />}
          />
          <Route
            path="/news-room-media/photo-gallery"
            element={<PhotoGalleryAndEvents />}
          />
          <Route
            path="/publication-detail/:nid"
            element={<PublicationDetailById />}
          />
          <Route path="/latest-news-detail" element={<LatestNewsPage />} />
          <Route path="/announcement-detail" element={<AnnouncementPage />} />
          {/* <Route
            path="/announcement-detail/:id"
            element={<AnnouncementById />}
          /> */}
          <Route
            path="/announcement-detail/:id"
            element={
              <HtmlPageById
                apiPath={"announcement"}
                title={getText("Announcement", "घोषणा")}
                titleLink={"/announcement-detail"}
              />
            }
          />

          <Route
            path="/photo-gallery-detail"
            element={<PhotoGalleryDetailPage />}
          />

          <Route
            path="/photo-gallery-detail/:nid"
            element={<PhotoDetailById />}
          />
          {/* latest news home */}
          <Route path="/latest-news-detail" element={<LatestNewsPage />} />
          <Route
            path="/latest-news-detail/:nid"
            element={<LatestNewsDetailPage />}
          />
          {/* events home  */}
          <Route path="/events-detail" element={<EventsDetailPage />} />
          <Route path="/events-detail/:id" element={<EventsDetailById />} />
        </>
        {/* reservoir detail page */}
        <Route
          path="/reservoir-status/:id"
          element={<WaterLevelsDetailPage />}
        />
        <Route path="/reservoir-status/abcde" element={<WaterTemp />} />
        <Route path="/rain-fall/:id" element={<RainFallDetailPage />} />
        <Route path="/swachh-bharat-photos" element={<SwachBharatPhotos />} />
        {/* footer bottom menu pages */}
        <>
          <Route
            path="/terms-and-conditions"
            element={<FooterBottomPage id={453} />}
          ></Route>
          <Route
            path="/privacy-policy"
            element={<FooterBottomPage id={454} />}
          ></Route>
          <Route
            path="/copyright-policy"
            element={<FooterBottomPage id={455} />}
          ></Route>
          <Route
            path="/hyperlink-policy"
            element={<FooterBottomPage id={456} />}
          ></Route>
          <Route
            path="/accessibility-statement"
            element={<FooterBottomPage id={457} />}
          ></Route>
          <Route
            path="/disclaimer"
            element={<FooterBottomPage id={28741} />}
          ></Route>
          <Route
            path="/privacy-statement"
            element={<FooterBottomPage id={28743} />}
          ></Route>
          <Route
            path="/web-information-manager"
            element={<FooterBottomPage id={37303} />}
          ></Route>
          {/* <Route path="/disclaimer" element={<Disclaimer />}></Route> */}
          <Route path="/website-policies" element={<WebsitePolicies />}></Route>
          {/* <Route
            path="/privacy-statement"
            element={<PrivacyStatement />}
          ></Route> */}
        </>
        {/* footer middle menu pages */}
        <>
          <Route path="/ex-employee-desk" element={<ExEmployeesPage />} />
          <Route path="/mse-startups" element={<MseStartups />} />
          <Route path="/archived-news" element={<ArchivedNews />} />
          <Route
            path="/archived-publications"
            element={<ArchivedPublications />}
          />
          <Route
            path="/news-archive/:nid"
            element={<ArchivedNewsDetailPage />}
          />
          <Route path="/help" element={<HelpPage />} />
          <Route
            path="/contractual-vendors"
            element={<ContractualVendorsPage />}
          />
          <Route path="/offer-works" element={<OfferWorks />} />
          <Route
            path="/bee-painting-competition"
            element={<BeePaintingCompetition />}
          />
          <Route
            path="/guideline-for-release"
            element={<GuideLineForReleasePage />}
          />

          <Route path="/archived-events" element={<EventArchivePage />} />
          <Route
            path="/archived-events/:id"
            element={<EventArchiveDetailPage />}
          />
        </>
        <Route path="*" element={<UnderConstruction />}></Route>
        <Route path="/awards" element={<Awards />} />
        {/* <Route path="/awards/:id" element={<AwardsDetailById />} /> */}
        <Route
          path="/awards/:id"
          element={
            <HtmlPageById
              apiPath={"awards_and_accreditation"}
              title={getText("Awards & Accreditation", "पुरस्कार एवं मान्यता")}
              titleLink={"/awards"}
            />
          }
        />
        <Route
          path="/mse-startups/:id"
          element={
            <HtmlPageById
              apiPath={"mse_startups"}
              title={getText("MSE & Startups", "एमएसई और स्टार्टअप")}
              titleLink={"/mse-startups"}
            />
          }
        />
        <Route path="/node-detail/:id" element={<HtmlPageByNode />} />
        <Route
          path="/performance-highlights"
          element={<PerformanceHighlights />}
        />
        <Route path="/r&d" element={<ResearchAndDevelopment />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/node/:id" element={<ExternalPage />} />
        <Route path="/page/:id" element={<ExternalPage />} />
        <Route path="/archive-section" element={<ArchiveFooterPage />} />{" "}
        <Route path="/property-return" element={<PropertyReturn />} />
        <Route
          path="/archived-photos"
          element={<PhotoGalleryArchiveDetailPage />}
        />
        <Route
          path="/archive-photo-gallery-detail/:nid"
          element={<PhotoDetailByIdArchive />}
        />
        <Route
          path="/comprehensive-guideline"
          element={<ComprehensiveGuidelinePage />}
        />
      </Routes>
    </>
  );
}

export default AppRouting;
